type OnboardingType = 'formation' | 'takeover' | null;

/**
 * Determines if the member is going through formation or takeover based on usertype.
 *
 * Formation: SP-LLC, SP-SC (Sole Proprietor creating new business)
 * Takeover: LLC-LLC, LLC-SC, SC-SC (Existing business transitioning)
 */
export function getOnboardingType(usertype: string | undefined): OnboardingType {
    if (!usertype) {
        return null;
    }

    const source = usertype.split('-')[0];

    switch (source) {
        case 'SP':
            return 'formation';
        case 'LLC':
        case 'SC':
            return 'takeover';
        default:
            return null;
    }
}
